import { render, staticRenderFns } from "./RuleCustomListPrice.vue?vue&type=template&id=510e557a&scoped=true"
import script from "./RuleCustomListPrice.vue?vue&type=script&lang=js"
export * from "./RuleCustomListPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e557a",
  null
  
)

export default component.exports